import Box from '@mui/material/Box';

const Content = ({ children }) => {
    return (
        <Box
            sx={{
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                padding: '20px 30px',
                width: '100%'
            }}
        >
            {children}
        </Box>
    );
};

export default Content;
